import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api';

export default function InventarPage() {
  const [inventar, setInventar] = useState([]);
  const [laden, setLaden] = useState(true);
  const [filter, setFilter] = useState('');
  const navigate = useNavigate();

  useEffect(() => { laden_daten(); }, []);

  async function laden_daten() {
    setLaden(true);
    const r = await api.get('/inventar');
    setInventar(r.data);
    setLaden(false);
  }

  async function pdfExport() {
    const { jsPDF } = await import('jspdf');
    const { default: autoTable } = await import('jspdf-autotable');
    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text('Lager Inventar', 14, 20);
    doc.setFontSize(10);
    doc.text(`Erstellt: ${new Date().toLocaleDateString('de-DE')}`, 14, 28);
    const gefiltert = filter ? inventar.filter(i =>
      i.artikel.toLowerCase().includes(filter.toLowerCase()) ||
      i.behaelter.toLowerCase().includes(filter.toLowerCase()) ||
      (i.standort||'').toLowerCase().includes(filter.toLowerCase()) ||
      (i.kategorie||'').toLowerCase().includes(filter.toLowerCase())
    ) : inventar;
    autoTable(doc, {
      startY: 35,
      head: [['Standort', 'Kiste', 'Artikel', 'Menge', 'Einheit', 'Kategorie']],
      body: gefiltert.map(i => [i.standort||'–', i.behaelter, i.artikel, i.menge, i.einheit, i.kategorie||'–']),
      headStyles: { fillColor: [245, 158, 11] },
      styles: { fontSize: 8 },
      alternateRowStyles: { fillColor: [255, 251, 235] }
    });
    doc.save(`Inventar_${new Date().toLocaleDateString('de-DE').replace(/\./g,'-')}.pdf`);
  }

  const gefilter = filter ? inventar.filter(i =>
    i.artikel.toLowerCase().includes(filter.toLowerCase()) ||
    i.behaelter.toLowerCase().includes(filter.toLowerCase()) ||
    (i.standort||'').toLowerCase().includes(filter.toLowerCase()) ||
    (i.kategorie||'').toLowerCase().includes(filter.toLowerCase())
  ) : inventar;

  const gruppen = {};
  gefilter.forEach(i => {
    const key = `${i.standort_icon||'📦'} ${i.standort||'Kein Standort'} › ${i.behaelter}`;
    if (!gruppen[key]) gruppen[key] = { farbe: i.behaelter_farbe, behaelter_id: i.behaelter_id, items: [] };
    gruppen[key].items.push(i);
  });

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
        <h1 style={{ margin: 0, fontSize: '22px', fontWeight: '700' }}>📋 Inventar</h1>
        <button onClick={pdfExport} disabled={inventar.length === 0}
          style={{ padding: '10px 14px', background: inventar.length === 0 ? '#e2e8f0' : '#f59e0b', color: inventar.length === 0 ? '#94a3b8' : 'white', border: 'none', borderRadius: '10px', cursor: inventar.length === 0 ? 'not-allowed' : 'pointer', fontWeight: '600', fontSize: '13px' }}>
          📄 PDF exportieren
        </button>
      </div>
      <p style={{ color: '#64748b', fontSize: '13px', marginTop: '4px', marginBottom: '12px' }}>Alle Artikel in allen Kisten auf einen Blick.</p>

      <input value={filter} onChange={e => setFilter(e.target.value)}
        placeholder="Artikel, Kiste oder Standort filtern..."
        aria-label="Inventar filtern"
        style={{ width: '100%', padding: '10px 14px', borderRadius: '10px', border: '1px solid #e2e8f0', fontSize: '14px', boxSizing: 'border-box', marginBottom: '16px' }} />

      {laden && <div style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>⏳ Inventar wird geladen...</div>}

      {!laden && inventar.length === 0 && (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#94a3b8' }}>
          <div style={{ fontSize: '48px' }}>📋</div>
          <div style={{ marginTop: '12px', fontWeight: '600', fontSize: '16px', color: '#64748b' }}>Das Inventar ist noch leer</div>
          <div style={{ fontSize: '13px', marginTop: '6px', marginBottom: '20px' }}>Lege Kisten an und füge Artikel hinzu – sie erscheinen dann hier.</div>
          <button onClick={() => navigate('/behaelter')}
            style={{ padding: '12px 24px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '10px', fontWeight: '700', cursor: 'pointer' }}>
            Zu den Kisten
          </button>
        </div>
      )}

      {!laden && inventar.length > 0 && gefilter.length === 0 && (
        <div style={{ textAlign: 'center', padding: '40px 20px', color: '#94a3b8' }}>
          <div style={{ fontSize: '40px' }}>🔍</div>
          <div style={{ marginTop: '8px', fontWeight: '600', color: '#64748b' }}>Kein Eintrag für „{filter}"</div>
          <button onClick={() => setFilter('')}
            style={{ marginTop: '12px', padding: '8px 16px', background: '#f1f5f9', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>
            Filter zurücksetzen
          </button>
        </div>
      )}

      {!laden && gefilter.length > 0 && (
        <div style={{ marginBottom: '8px', color: '#64748b', fontSize: '13px' }}>{gefilter.length} Artikel</div>
      )}

      {Object.entries(gruppen).map(([key, g]) => (
        <div key={key} style={{ marginBottom: '16px' }}>
          <Link to={`/behaelter/${g.behaelter_id}`}
            style={{ display: 'block', fontWeight: '700', fontSize: '12px', color: '#64748b', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px', borderLeft: `3px solid ${g.farbe||'#f59e0b'}`, paddingLeft: '8px', textDecoration: 'none' }}>
            {key} <span style={{ fontWeight: '400', fontSize: '11px' }}>→ Kiste öffnen</span>
          </Link>
          {g.items.map((item, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 12px', background: 'white', borderRadius: '8px', marginBottom: '4px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', fontSize: '14px' }}>
              <div>
                <span style={{ fontWeight: '600' }}>{item.artikel}</span>
                {item.kategorie && <span style={{ color: '#94a3b8', fontSize: '11px', marginLeft: '8px' }}>{item.kategorie}</span>}
                {item.beschreibung && <div style={{ color: '#94a3b8', fontSize: '11px' }}>{item.beschreibung}</div>}
              </div>
              <span style={{ color: '#64748b', whiteSpace: 'nowrap', marginLeft: '8px' }}>{item.menge} {item.einheit}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
